import {AxiosResponse} from 'axios'
import {ListPersonTagRequest, PhotoPersonTag} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface ListPhotoTags<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const listPhotoTags: ListPhotoTags<
  ListPersonTagRequest,
  PhotoPersonTag
> = (http, params) => {
  const {ClientID, PageNumber, PageSize, PersonID} = params

  const path = '/v1/photos/person-tags/{personid}'.replace(
    '{personid}',
    PersonID.toString(),
  )

  return http.request<PhotoPersonTag>({
    method: 'GET',
    url: `${path}?clientid=${ClientID}&pagenumber=${PageNumber}&pagesize=${PageSize}`,
  })
}
